<div class="rewardship-table">
    <div class="no-result" *ngIf="!dataSource">
        <span>{{'NoResult'|translate}}.</span>
    </div>
    <mat-table #table [dataSource]="dataSource">
        <ng-container matColumnDef="InvoiceID">
            <mat-header-cell *matHeaderCellDef>{{'InvoiceId'|translate}}</mat-header-cell>
            <mat-cell *matCellDef="let row">{{ row.InvoiceID }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="ActivityDate">
            <mat-header-cell *matHeaderCellDef>{{'ActivityDate'|translate}}</mat-header-cell>
            <mat-cell *matCellDef="let row">{{ row.ActivityDate | date : 'MM/dd/yyyy' }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="DueDate">
            <mat-header-cell *matHeaderCellDef>{{'DueDate'|translate}}</mat-header-cell>
            <mat-cell *matCellDef="let row">{{ row.DueDate }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="PaidDate">
            <mat-header-cell *matHeaderCellDef>{{'DatePaid'|translate}}</mat-header-cell>
            <mat-cell *matCellDef="let row">{{ row.PaidDate }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="PotentialPoints">
            <mat-header-cell *matHeaderCellDef>{{'CreditsinProgress'|translate}}</mat-header-cell>
            <mat-cell *matCellDef="let row">{{ row.PotentialPoints }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="AvailablePoints">
            <mat-header-cell *matHeaderCellDef>{{'AvailableCredits'|translate}}</mat-header-cell>
            <mat-cell *matCellDef="let row">{{ row.AvailablePoints }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="RedeemedPoints">
            <mat-header-cell *matHeaderCellDef>{{'Redeemed'|translate}}</mat-header-cell>
            <mat-cell *matCellDef="let row">{{ row.RedeemedPoints }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="ForfeitedPoints">
            <mat-header-cell *matHeaderCellDef>{{'Forfeited'|translate}}</mat-header-cell>
            <mat-cell *matCellDef="let row">{{ row.ForfeitedPoints }}</mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>
    <mat-paginator #paginator *ngIf="totalItems"
                  [length]="totalItems"
                  [pageIndex]="0"
                  [pageSize]="5"
                  [pageSizeOptions]="[5, 10, 25, 100]"
                  (page)="onPageChanged($event)">
    </mat-paginator>
</div>